'use strict';

//dependencies included for running in node
if (typeof exports !== 'undefined') {
  if (typeof module !== 'undefined' && module.exports) {
    var AgeIndexedModelOutput = require('../lib/ageIndexedModelOutput');
    var AdvDate = require('js-utils/src/util/advDate');
    var AutoEnrolmentType = require('../lib/autoEnrolmentType');
  }
}

var Account = function(p) {
  this.p = p;
  this.age = p.ageNow();
  this.calculationDate = p.model.calculationDate;
  this.salary = p.person.salary;
  this.currentFund = p.person.currentFund;
  this.preRetirementInvestmentReturn = p.preRetirementInvestmentTable.getReturn(p.person.preRetirementInvestment);
  this.monthsToRetirement = p.monthsToRetirement();
  this.monthsToFirstAutoEnrolmentDate = p.monthsToFirstAutoEnrolmentDate();
  this.monthsToSecondAutoEnrolmentDate = p.monthsToSecondAutoEnrolmentDate();
  this.autoEnrolmentTotalRatePhaseA = p.model.autoEnrolmentTotalRatePhaseA;
  this.autoEnrolmentTotalRatePhaseB = p.model.autoEnrolmentTotalRatePhaseB;
  this.autoEnrolmentTotalRatePhaseC = p.model.autoEnrolmentTotalRatePhaseC;
  this.salaryIncreaseMonth = p.model.salaryIncreaseMonth;
  this.salaryIncrease = p.model.salaryIncrease;
  this.retirementAge = p.retirementAge();
  this.discountRate = p.model.discountRate;
  this.futureTerms = p.model.futureTerms;
  this.autoEnrolmentType = p.model.autoEnrolmentType;

  //outputs
  this.fundOutput = {};
  this.salaryOutput = {};
};

Account.prototype.accumulate = function() {
  var currentMonth = this.calculationDate.getMonth();
  var futureSalary = [this.salary];
  //var totalContributionRate = this.contributionRate + this.employerContributionRate; 
  var futureFund = [this.currentFund];
  var monthlyPreRetirementInvestmentReturn = Math.pow(1 + this.preRetirementInvestmentReturn, 1 / AdvDate.MONTHS_IN_YEAR) - 1;


  this.fundOutput = new AgeIndexedModelOutput(this.age);
  this.salaryOutput = new AgeIndexedModelOutput(this.age);
  
  if(!this.futureTerms) {
    // loop is starting after 1 month, so apply an extra month of discounting to the discounted values
    var deflationPeriod = this.monthsToRetirement <= 0 ? 0 : 1;
    this.fundOutput.useDeflatedOutput(this.discountRate, deflationPeriod);
    this.salaryOutput.useDeflatedOutput(this.discountRate, deflationPeriod);
  }
  
  // if already at retirement, the accumulation loop will not run
  // just set future fund value and salary to current
  if (this.monthsToRetirement <= 0) {
    this.fundOutput.setValue(futureFund[0]);
    this.salaryOutput.setValue(futureSalary[0]); 
  }

  for(var monthCounter = 1; monthCounter <= this.monthsToRetirement; monthCounter++) {
    if(currentMonth == this.salaryIncreaseMonth) {
      futureSalary[monthCounter] = futureSalary[monthCounter - 1] * (1 + this.salaryIncrease);
    }
    else {
      futureSalary[monthCounter] = futureSalary[monthCounter - 1];  
    }


    // apply minimum auto enrolment if required
    // TODO - check what happens when today's date is greater than a switch date
    if (this.autoEnrolmentType == AutoEnrolmentType.INCLUDE) {
      // do this;
      if (monthCounter < this.monthsToFirstAutoEnrolmentDate) {
        totalContributionRate = Math.max(this.autoEnrolmentTotalRatePhaseA, totalContributionRate);
      } else if (monthCounter < this.monthsToSecondAutoEnrolmentDate) {
        totalContributionRate = Math.max(this.autoEnrolmentTotalRatePhaseB, totalContributionRate);
      } else {
        totalContributionRate = Math.max(this.autoEnrolmentTotalRatePhaseC, totalContributionRate);
      }
    } 

    var employeeRate = this.p.getEeContributionRate();
    var totalContributionRate = employeeRate + this.p.getErContributionRate(employeeRate, monthCounter / AdvDate.MONTHS_IN_YEAR);
    var contribution = (futureSalary[monthCounter] * totalContributionRate) / AdvDate.MONTHS_IN_YEAR;
    futureFund[monthCounter] = futureFund[monthCounter - 1] + (futureFund[monthCounter - 1] * monthlyPreRetirementInvestmentReturn) + contribution;
    currentMonth++;
    currentMonth = currentMonth % AdvDate.MONTHS_IN_YEAR;

    //generate monthly outputs
    this.fundOutput.setValue(futureFund[monthCounter]);
    this.salaryOutput.setValue(futureSalary[monthCounter]);
  }
};

// ability to set fund value at retirement directly if external accumulation model is used
// values set this way are not discounted (assumed to already be the case if discounted values are to be used)
Account.prototype.setFund = function(fund) {
  this.fundOutput = new AgeIndexedModelOutput(this.retirementAge);
  this.fundOutput.setValue(fund);
};

Account.prototype.setSalary = function(salary) {
  this.salaryOutput = new AgeIndexedModelOutput(this.retirementAge);
  this.salaryOutput.setValue(salary);
};

Account.prototype.getFund = function() {
  return this.fundOutput;
};

Account.prototype.getSalary = function() {
  return this.salaryOutput;
};

//export for node
if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = Account;
    }
    exports.Account = Account;
}